import { render, staticRenderFns } from "./EntityEvents.yaml?vue&type=template&id=0d007b46&component"
import script from "./EntityEvents.yaml?vue&type=script&lang=ts&component"
export * from "./EntityEvents.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports